import React from "react";
import { observer } from "mobx-react-lite";
import { managementStore } from "../../stores/ManagementStore";
import { RiDeleteBack2Line } from "react-icons/ri";
import { HiOutlineRefresh } from "react-icons/hi";
import { generateUniqueAccesscode } from "../../../shared/helper/accesscodeHelpers";
import { userStore } from "../../stores/UserStore";
export const AccessCode = observer(({
  value,
  setValue,
  config,
  disabled = false
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    disabled: disabled,
    readOnly: true,
    value: value
  }), userStore.mayEditAllWorkshops && /*#__PURE__*/React.createElement(React.Fragment, null, "\u2002", /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    onClick: () => setValue("")
  }, /*#__PURE__*/React.createElement(RiDeleteBack2Line, null)), "\u2002", /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    onClick: () => setValue(generateUniqueAccesscode(config, managementStore.accessCodeExists))
  }, /*#__PURE__*/React.createElement(HiOutlineRefresh, null))));
});